

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { SuppliersContext } from '../../context/supplier/SupplierContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';




export const SupplierPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { addSupplier, updateSupplier, loadTypeService } = useContext(SuppliersContext);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [services, setServices] = useState([]);
    const required = useRequiredFields();

    var supplier;

    if (state) {
        supplier = state.supplier;
    } else {
        supplier = {
            supplierCode: -1,
            serviceTypeId: -1,
            name: '',
            legalId: '',
            phone: '',
            mobile: '',
            address: '',
            email: '',
            contact: ''
        }
    }


    const { formState, onInputChange } = useForm(supplier);

    const { supplierCode, serviceTypeId, name, legalId, phone, mobile, address, email, contact } = formState

    /*useEffect(() => {
        const formValid = serviceTypeId > 0 && name.length > 0 && legalId.length > 0
        setIsFormValid(formValid);
    }, [serviceTypeId, name])*/

    useEffect(() => {
        loadTypeService().then((servs) => setServices(servs));
    }, [])




    const handleSave = async () => {

        const formValid = serviceTypeId > 0 && name.length > 0
        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos.");
            return false;
        }

        var resp = "";
        if (supplierCode > 0) {
            resp = await updateSupplier(formState);
        } else {
            resp = await addSupplier(formState);
        }
        if (resp == "success") {
            setSuccessMessage(supplierCode > 0 ? "Proveedor actualizado correctamente" : "Proveedor creado correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{supplierCode > 0 ? 'Actualizar proveedor' : 'Crear proveedor'}</h3>
                <hr />

                <form className="row g-3 " >

                    <div className="mb-3">
                        <label htmlFor="typeServiceSelect" className="form-label">Tipo de servicio *</label>
                        <select id='typeServiceSelect' className={`form-select${required.mark(!(serviceTypeId > 0))}`} name='serviceTypeId' value={serviceTypeId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {services.length > 0
                                ?
                                services.map(service => (
                                    <option key={service.id} value={service.id} >{service.description}</option>
                                ))
                                :
                                <option selected>No hay servicios disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>



                    <div className="mb-3">
                        <label htmlFor="supplierNameInput" className="form-label">Nombre *</label>
                        <input
                            id='supplierNameInput'
                            type="text"
                            className={`form-control${required.mark(!name)}`}
                            placeholder="Nombre"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="legalIdInput" className="form-label">Identificación</label>
                        <input
                            id='legalIdInput'
                            type="text"
                            className={`form-control `}
                            placeholder="Identificación"
                            name="legalId"
                            value={legalId}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="phoneInput" className="form-label">Teléfono</label>
                        <input
                            id='phoneInput'
                            type="text"
                            className={`form-control `}
                            placeholder="Teléfono"
                            name="phone"
                            value={phone}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="mobileInput" className="form-label">Celular</label>
                        <input
                            id='mobileInput'
                            type="text"
                            className={`form-control `}
                            placeholder="Celular"
                            name="mobile"
                            value={mobile}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="emailInput" className="form-label">Correo</label>
                        <input
                            id='emailInput'
                            type="text"
                            className={`form-control `}
                            placeholder="Correo"
                            name="email"
                            value={email}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="contactInput" className="form-label">Persona Contacto</label>
                        <input
                            id='contactInput'
                            type="text"
                            className={`form-control `}
                            placeholder="Persona Contacto"
                            name="contact"
                            value={contact}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="addressInput" className="form-label">Dirección</label>
                        <input
                            id='addressInput'
                            type="text"
                            className={`form-control `}
                            placeholder="Dirección"
                            name="address"
                            value={address}
                            onChange={onInputChange}
                            required
                        />
                    </div>





                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
